import React from 'react';
// @ts-ignore
import { Button } from 'arag-ui-lib';
import styles from './claimOverview.module.scss';
import ids from '../../utils/constants/ids';
import questionProjections from '../../projections/question';
import codes from '../../utils/constants/codes';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import { ClaimApplicationProjections } from '../../actions/claimApplication';
import { useAppSelector } from '../../hooks/hooks';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/i18n';
// types
type ClaimOverviewRowProps = {
    leftSide: () => JSX.Element | boolean;
    rightSide: () => JSX.Element | boolean;
};
type ClaimOverviewPros = {
    claimApplication: Partial<ClaimApplicationProjections>;
    openWithdrawModal: () => void;
};

export const ClaimOverviewRow = ({
    leftSide,
    rightSide,
}: ClaimOverviewRowProps): JSX.Element => {
    return (
        <div className={`row ${styles['claim-overview-row']}`}>
            <div className={'col-sm-6'}>{leftSide && leftSide()}</div>
            <div className={'col-sm-6'}>{rightSide && rightSide()}</div>
        </div>
    );
};

const ClaimOverview = (props: ClaimOverviewPros): JSX.Element | null => {
    const { claimApplication, openWithdrawModal } = props;
    const withDrawQuestionsExist = useAppSelector(
        questionProjections.areQuestionsByGroupCodeExist(
            codes.updateWithdrawnDetailsGroupCode,
        ),
    );
    const { t } = useTranslation();
    if (!claimApplication) {
        return null;
    }
    return (
        <div>
            <ClaimOverviewRow
                leftSide={() => (
                    <div>
                        <span>{`${t('formType')}: `}</span>
                        <strong>{claimApplication.formattedType}</strong>
                    </div>
                )}
                rightSide={() => (
                    <div>
                        <span>{`${t('claimHandlerName')}: `}</span>
                        <strong>
                            {claimApplication.claimHandlerName
                                ? claimApplication.claimHandlerName
                                : (i18n.t('notYetAssigned') as string)}
                        </strong>
                    </div>
                )}
            />
            <ClaimOverviewRow
                leftSide={() => (
                    <div>
                        <span>{`${t('stage')}: `}</span>
                        <strong>{claimApplication.claimStatusName}</strong>
                    </div>
                )}
                rightSide={() => (
                    <div className={'row'}>
                        <div className={'col-sm-6'}>
                            <span>{`${t('dateCreated')}: `}</span>
                            <strong>
                                {GENERAL_FUNCTIONS.dateFormat(
                                    claimApplication?.createdDate,
                                )}
                            </strong>
                        </div>
                    </div>
                )}
            />
            <ClaimOverviewRow
                leftSide={() => (
                    <div>
                        <span>{`${t('state')}: `} </span>
                        <strong>{claimApplication.claimStateName}</strong>
                    </div>
                )}
                rightSide={() =>
                    !withDrawQuestionsExist && (
                        <div className={styles['edit-claim-btn-wrapper']}>
                            <Button
                                onClick={openWithdrawModal}
                                variant="danger"
                                label={t('withdrawClaim')}
                                arrowDirection="right"
                            />
                        </div>
                    )
                }
            />
        </div>
    );
};

export default ClaimOverview;
